import { render } from "./ContentblockFullscreenImage.vue?vue&type=template&id=418f978c&scoped=true&ts=true"
import script from "./ContentblockFullscreenImage.ts?vue&type=script&lang=ts"
export * from "./ContentblockFullscreenImage.ts?vue&type=script&lang=ts"

import "./ContentblockFullscreenImage.scss?vue&type=style&index=0&id=418f978c&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418f978c"]])

export default __exports__